import { render, staticRenderFns } from "./dosage-control.vue?vue&type=template&id=4a5c8674&scoped=true&"
import script from "./dosage-control.vue?vue&type=script&lang=js&"
export * from "./dosage-control.vue?vue&type=script&lang=js&"
import style0 from "./dosage-control.vue?vue&type=style&index=0&id=4a5c8674&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c8674",
  null
  
)

export default component.exports